<ng-container>

    <!--Months-->
    <div class="tableFilters">
        <ng-container *ngIf="hasMonthFilter">
            <mat-form-field appearance="outline" class="filter-field">
                <mat-label>Meses</mat-label>
                <mat-icon matPrefix>date_range</mat-icon>
                <mat-select [formControl]="months" multiple
                    (selectionChange)="onChangeMonth($event)" (openedChange)="onFocusSelect($event)" #monthSelect>
                    <mat-checkbox (change)='onSelectAll($event)' class="ps-3" [(ngModel)]="allMonthsSelected">
                        Todos
                    </mat-checkbox>
                    <mat-select-trigger>
                        <span *ngIf="allMonthsSelected">Todos</span>
                        <span *ngIf="!allMonthsSelected">{{ getSelectedMonthsNames() }}</span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let card of monthList; trackBy: trackByIndex" [value]="card.number">
                        {{card.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
        <!--Filter-->
        <ng-container *ngIf="!hasObservableFilter && hasFilterOldObservable">
            <mat-form-field appearance="outline" class="filter-field">
                <mat-label>Filtro</mat-label>
                <mat-icon matPrefix>search</mat-icon>
                <input matInput [(ngModel)]="filter" (keyup)="applyFilter($event.target.value)" placeholder="Buscar...">
            </mat-form-field>
        </ng-container>

        <ng-container *ngIf="hasObservableFilter">
            <mat-form-field appearance="outline" class="filter-field">
                <mat-label>Filtro</mat-label>
                <mat-icon matPrefix>search</mat-icon>
                <input matInput [(ngModel)]="filter" (keydown.enter)="keyDownEnterPress($event)" placeholder="Buscar...">
            </mat-form-field>
        </ng-container>

        <ng-container *ngIf="hasObservableFilter">
            <div class="butonera">
                <button mat-flat-button color="primary" (click)="applyFilter(filter)">
                    <mat-icon>search</mat-icon> Buscar
                </button>
            </div>
        </ng-container>

        <ng-content select="[filterBarActions]"></ng-content>

        <!--Totales-->
        <ng-container *ngIf="showTotals">

            <div class="totals-container container-fluid m-0">
                <div class="row justify-content-center">

                    <!-- Total -->
                    <div class="col-auto" *ngIf="irpfTotals == false">
                        <div class="total-card">
                            <p class="label">Total</p>
                            <p class="value">{{ total | number:'1.2-2' }} €</p>
                        </div>
                    </div>

                    <!-- Base -->
                    <div class="col-auto" *ngIf="irpfTotals == true">
                        <div class="total-card">
                            <p class="label">Base</p>
                            <p class="value">{{ base | number:'1.2-2' }} €</p>
                        </div>
                    </div>

                    <!-- Retenciones -->
                    <div class="col-auto" *ngIf="irpfTotals == true">
                        <div class="total-card">
                            <p class="label">Retenciones</p>
                            <p class="value text-danger">{{ irpfAmount | number:'1.2-2' }} €</p>
                        </div>
                    </div>

                    <!-- Pagado -->
                    <div class="col-auto" *ngIf="showTotals && showTotalsHasOptionToPay">
                        <div class="total-card">
                            <p class="label">{{ textPaided }}</p>
                            <p class="value text-success">{{ totalPaided | number:'1.2-2' }} €</p>
                        </div>
                    </div>

                    <!-- Pendiente -->
                    <div class="col-auto" *ngIf="showTotals && showTotalsHasOptionToPay">
                        <div class="total-card">
                            <p class="label">{{ textUnpaid }}</p>
                            <p class="value text-warning">{{ totalUnpaided | number:'1.2-2' }} €</p>
                        </div>
                    </div>

                </div>
            </div>


        </ng-container>

    </div>
    <div class="table-responsive mb-3 scrollbar-primary">
        <table mat-table [dataSource]="dataTable" matSort class="mat-elevation-z8 toplineBlue">

            <!-- Si tienes una columna de selección -->
            <ng-container *ngIf="hasSelect && !hasCondSelect">
                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef class="th-bg">
                        <mat-checkbox (change)="$event ? masterToggle() : null"
                            [checked]="selection.hasValue() && isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-checkbox (click)="$event.stopPropagation()"
                            (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"
                            [aria-label]="checkboxLabel(row)">
                        </mat-checkbox>
                    </td>
                </ng-container>
            </ng-container>

            <!-- Columna dinámica según tu definición de columnas -->
            <ng-container *ngFor="let column of columns; trackBy: trackByIndex">

                <ng-container matColumnDef="{{column.field}}">

                    <!-- Cabecera de columna -->
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-bg">
                        {{ column.title }}
                    </th>

                    <!-- Celda de columna -->
                    <td mat-cell *matCellDef="let row">

                        <!-- Caso especial: comentarios/anotaciones panel admin -->
                        <ng-container *ngIf="column.field === 'commentsPanelAdminCustom'">
                            <span [matTooltip]="column.cell(row)"
                                (click)="handleCommentsAdminPanelUserClick(row.userId)">
                                <mat-icon>comment</mat-icon>
                            </span>
                        </ng-container>

                        <!-- Caso especial: si es la columna de numero justificante de Justificantes -->
                        <ng-container *ngIf="column.field === 'receiptNumber'">
                            <span class="clickable" (click)="handleReceiptNumber(row)">
                                {{ row.receiptNumber }}
                            </span>
                        </ng-container>

                        <!-- Caso especial: si es la columna de cantidad de Justificantes -->
                        <ng-container *ngIf="column.field === 'amount'">
                            <span class="clickable" (click)="handleAmount(row)">
                                {{ row.amount }}
                            </span>
                        </ng-container>

                        <!-- Caso especial: si es la columna de name de Concepts/Contactos -->
                        <ng-container *ngIf="column.field === 'name'">
                            <span class="clickable" (click)="handleNameConceptClick(row)">
                                {{ row.name }}
                            </span>
                        </ng-container>

                        <!-- Caso especial: si es la columna de elementDescription de Inversiones -->
                        <ng-container *ngIf="column.field === 'elementDescription'">
                            <span class="clickable" (click)="handleDescriptionInvestmentClick(row)">
                                {{ row.elementDescription }}
                            </span>
                        </ng-container>

                        <!-- Caso especial: si es la columna de provider de Inversiones -->
                        <ng-container *ngIf="column.field === 'provider'">
                            <span class="clickable" (click)="handleProviderInvestmentClick(row)">
                                {{ row.provider }}
                            </span>
                        </ng-container>

                        <!-- Caso especial: si es la columna de preInvoiceNumber -->
                        <ng-container *ngIf="column.field === 'preInvoiceNumber'">
                            <span class="clickable" (click)="handlePreInvoiceNumberClick(row)">
                                {{ row.preInvoiceNumber }}
                            </span>
                        </ng-container>

                        <ng-container *ngIf="column.field === 'issuerName'">
                            <span class="clickable" (click)="handlePreInvoiceIssuerClick(row)">
                                {{ row.issuerName }}
                            </span>
                        </ng-container>

                        <!-- Caso especial: si es la columna del issuer de Preinvoice -->
                        <ng-container *ngIf="column.field === 'receiverName'">
                            <span class="clickable" (click)="handlePreInvoiceIssuerClick(row)">
                                {{ row.receiverName }}
                            </span>
                        </ng-container>

                        <!-- Caso especial: si es la columna de recurrentNumber -->
                        <ng-container *ngIf="column.field === 'recurrentNumber'">
                            <span class="clickable" (click)="handleRecurrentNumberClick(row)">
                                {{ row.recurrentNumber }}
                            </span>
                        </ng-container>

                        <!-- Caso especial: si es la columna de ticketNumber -->
                        <ng-container *ngIf="column.field === 'ticketNumber'">
                            <span class="clickable" (click)="handleTicketNumberClick(row)">
                                {{ row.ticketNumber }}
                            </span>
                        </ng-container>

                        <!-- Caso especial: si es la columna de invoiceNumber -->
                        <ng-container *ngIf="column.field === 'invoiceNumber'">
                            <span class="clickable" (click)="handleInvoiceNumberClick(row)">
                                {{ row.invoiceNumber }}
                            </span>
                        </ng-container>

                        <!-- Caso especial: si es la columna de total -->
                        <ng-container *ngIf="column.field === 'total'">
                            <span class="clickable" (click)="handleAmountNumberClick(row)">
                                {{ row.total }}
                            </span>
                        </ng-container>

                        <!-- Caso especial: columna cuenta contable cliente Contactos  -->
                        <ng-container *ngIf="column.field === 'entranceAccountClient'">
                            <span class="clickable" (click)="handleEntranceAccountClient(row)">
                                {{ row.entranceAccountClient }}
                            </span>
                        </ng-container>

                        <!-- Caso especial: columna cuenta contable proveedor Contactos  -->
                        <ng-container *ngIf="column.field === 'entranceAccountProvider'">
                            <span class="clickable" (click)="handleEntranceAccountProvider(row)">
                                {{ row.entranceAccountProvider }}
                            </span>
                        </ng-container>

                        <!-- Nominas, nombre empleado, salariobruto, salarioneto, segsocialCompany, segsocialWorker -->
                        <ng-container *ngIf="column.field === 'employee_name'">
                            <span class="clickable" (click)="handleEmployeeNameClick(row)">
                                {{ row.employee_name }}
                            </span>
                        </ng-container>

                        <ng-container *ngIf="column.field === 'salaryBrut'">
                            <span class="clickable" (click)="handleSalaryBrutClick(row)">
                                {{ row.salaryBrut }}
                            </span>
                        </ng-container>

                        <ng-container *ngIf="column.field === 'salaryNet'">
                            <span class="clickable" (click)="handleSalaryNetClick(row)">
                                {{ row.salaryNet }}
                            </span>
                        </ng-container>

                        <ng-container *ngIf="column.field === 'segSocialCompany'">
                            <span class="clickable" (click)="handleSegSocialCompanyClick(row)">
                                {{ row.segSocialCompany }}
                            </span>
                        </ng-container>

                        <ng-container *ngIf="column.field === 'segSocialWorker'">
                            <span class="clickable" (click)="handleSegSocialWorkerClick(row)">
                                {{ row.segSocialWorker }}
                            </span>
                        </ng-container>
                        <!-------------------------------------------------------------------------------------------->

                        <!-- Columna editable para 'units' -->
                        <ng-container *ngIf="column.field === 'units'">
                            <input type="number" class="form-control" [value]="row.units"
                                (input)="onUnitsInput($event, row)" (keydown.enter)="onUnitsSubmit(row)"
                                style="width: 80px;">
                        </ng-container>

                        <!-- Otras columnas dinámicas (excluyendo 'units') -->
                        <ng-container *ngIf="column.field !== 'units' &&
                                             column.field !== 'preInvoiceNumber' &&
                                             column.field !== 'commentsPanelAdminCustom' &&
                                             column.field !== 'invoiceNumber' &&
                                             column.field !== 'total' &&
                                             column.field !== 'recurrentNumber' &&
                                             column.field !== 'receiverName' &&
                                             column.field !== 'ticketNumber' &&
                                             column.field !== 'elementDescription' &&
                                             column.field !== 'provider' &&
                                             column.field !== 'name' &&
                                             column.field !== 'amount' &&
                                             column.field !== 'receiptNumber' &&
                                             column.field !== 'issuerName' &&
                                             column.field !== 'provider' &&
                                             column.field !== 'name' &&
                                             column.field !== 'issuerName' &&
                                             column.field !== 'amount' &&
                                             column.field !== 'receiptNumber' &&
                                             column.field !== 'entranceAccountClient' &&
                                             column.field !== 'entranceAccountProvider' &&
                                             column.field !== 'employee_name' &&
                                             column.field !== 'salaryBrut' &&
                                             column.field !== 'salaryNet' &&
                                             column.field !== 'segSocialCompany' &&
                                             column.field !== 'segSocialWorker' 
                                             ">

                            <ng-container *ngIf="hasRowClick">
                                <span ngClass="{{ column.class(row) }} click" *ngIf="column.field !== actions"
                                    (click)="clickRow(row)" [matTooltip]="getColumnTooltip(column, row)"
                                    [matTooltipDisabled]="disableColumnTooltip(column, row)" matTooltipPosition="above"
                                    matTooltipClass="comments-tooltip">
                                    <ng-container *ngIf="column.title === 'Actividad'">
                                        <ng-container *ngFor="let activity of activities; trackBy: trackByIndex">
                                            <ng-container *ngIf="activity.uid === column.cell(row)">
                                                {{ activity.name }}
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>

                                    <ng-container *ngIf="column.title !== 'Actividad'">
                                        {{ column.cell(row) }}
                                    </ng-container>
                                </span>
                            </ng-container>

                            <ng-container *ngIf="!hasRowClick">
                                <span ngClass="{{ column.class(row) }}" *ngIf="column.field !== actions"
                                    [matTooltip]="getColumnTooltip(column, row)"
                                    [matTooltipDisabled]="disableColumnTooltip(column, row)" matTooltipPosition="above"
                                    matTooltipClass="comments-tooltip">
                                    <ng-container *ngIf="column.title === 'Actividad'">
                                        <ng-container *ngFor="let activity of activities; trackBy: trackByIndex">
                                            <ng-container *ngIf="activity.uid === column.cell(row)">
                                                {{ activity.name }}
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>

                                    <ng-container *ngIf="column.title !== 'Actividad'">
                                        {{ column.cell(row) }}
                                    </ng-container>
                                </span>
                            </ng-container>

                        </ng-container>
                    </td>
                </ng-container>
            </ng-container>

            <!-- Columna para mostrar QR -->
            <ng-container *ngIf="hasShowQr" matColumnDef="showQr">
                <th mat-header-cell *matHeaderCellDef class="th-bg"> </th>
                <td mat-cell *matCellDef="let row">
                    <button mat-stroked-button [matMenuTriggerFor]="qr">Mostrar QR</button>
                    <mat-menu class="p-1" #qr="matMenu">
                        <qrcode [qrdata]="row.qrstring" [width]="128"></qrcode>
                    </mat-menu>
                </td>
            </ng-container>

            <!-- Columna de acciones -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="th-bg">
                    <ng-container *ngIf="hasHeaderActions">
                        <button class="btn-black" mat-stroked-button [matMenuTriggerFor]="actionsMenuHeader"
                            (click)="setSelected()">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                    </ng-container>
                </th>
                <td mat-cell *matCellDef="let row">
                    <ng-container *ngIf="actionsTemplate">
                        <button mat-stroked-button [matMenuTriggerFor]="actionsMenu" (click)="setRow(row)">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                    </ng-container>
                </td>
            </ng-container>

            <!-- Menú de acciones -->
            <mat-menu #actionsMenuHeader>
                <ng-container *ngIf="headerActionsTemplate">
                    <ng-container *ngTemplateOutlet="headerActionsTemplate; context: ctx"></ng-container>
                </ng-container>
            </mat-menu>
            <mat-menu #actionsMenu>
                <ng-container *ngIf="actionsTemplate">
                    <ng-container *ngTemplateOutlet="actionsTemplate; context: ctx"></ng-container>
                </ng-container>
            </mat-menu>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row class="bg-white" *matRowDef="let row; columns: displayedColumns;"
                [class.remark]="checkRemarkField(row)" [ngClass]="checkStyleRowPendingPay(row)"
                [matTooltip]="checkRemarkField(row) ? getRemarkMessage(row) : ''"></tr>

        </table>
    </div>
</ng-container>